<template>
    <div class="layout">
        <!-- 顶部导航 -->
        <SiteHeader :is_login_page="true"/>
        <div class="login-page">
          <p class="title">四为高管教育师资数据库</p>
          <form @submit.prevent="handleLogin">
              <p class="login_title">登陆</p>
              <input class="username" type="text" v-model="username" placeholder="员工邮箱" required />
              <input class="password" type="password" v-model="password" placeholder="密码" required />
              <p v-show="error" class="error">{{ error }}</p>
              <button class="login_btn" type="submit">登陆</button>
          </form>
        </div>
         <!-- 版权信息 -->
         <SiteFooter />
    </div>
  </template>
  
  <script>
  import SiteFooter from '@/components/SiteFooter.vue';
  import SiteHeader from '@/components/SiteHeader.vue';
  import axios from 'axios';
  export default {
    name: 'LoginPage',
    components: {
        SiteFooter,
        SiteHeader
    },
    data() {
      return {
        username: '',
        password: '',
        error: ''
      };
    },
    methods: {
      async handleLogin() {
        try {
            console.log(this.username)
            console.log(this.password)
            const response = await axios.get('https://pay.4reasons.cn/teacher-user/login', {
                params: {
                    username: this.username,
                    password: this.password
                }
            });

            const token = response.data.token;
            if(token != '')
            {
                localStorage.setItem('token', token); // 存储 token
                this.error = '';
                // alert('Login successful!');
                // this.$router.push('/StreamResponse'); // 跳转到主页
                this.$router.push('/welcome'); // 跳转到主页
            }
            else
            {
                this.error = '用户名或密码错误';
                console.error(this.error);
            }
        } catch (error) {
            this.error = '用户名或密码错误';
            console.error(error);
        }
      },
    },
  };
  </script>
  
  <style>
  * { 
    margin: 0; 
    padding: 0; 
    box-sizing: border-box; 
  }
  body{
    margin:0; 
    padding:0; 
    box-sizing: border-box; 
  }

  .layout {
    width: 100%;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: Arial, sans-serif;
    background-color: #f8f8f8;
    box-sizing: border-box;
    /* border:2px solid #0056b3; */
   }
  
  .login-page {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    height: calc(100vh - 87px - 76px);
    /* border: 1px solid red; */
    box-sizing: border-box;
  }
  .title{
    margin-top:114px;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    font-size: 28px;
    color: #565656;
    line-height: 36px;
  }
  form {
    margin-top:95px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 569px;
    height: 522px;
    border-radius: 10px;
    background-color: #FDFDFD;
  }
  .login_title{
    margin-top:44px;
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: 400;
    font-size: 28px;
    color: #4A4A4A;
    line-height: 51px;
  }
  input {
    padding: 20px;
    border: 1px solid #B3B3B3;
    border-radius: 5px;
    width:472px;
    height:64px;
    color:#4A4A4A;
  }
  ::placeholder {
    color: #BCBCBC; /* 设置为灰色 */
  }
  .username{
    margin-top:79px;
  }
  .password{
    margin-top:49px;
  }
  .login_btn{
    margin-top:44px;
    margin-bottom:61px;
  }
  button {
    padding-top:24px;
    padding-bottom:24px;
    background-color: #FF6864;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    width:465px;
    height:69px;
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: 400;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 46px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  button:hover {
    background-color: #ef0d0d;
  }
  .error{
    margin-top:20px;
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: 400;
    font-size: 18px;
    color:red;
    line-height: 12px;
  }

</style>